<template>
    <div v-if="menu && menu.length" class="page">
      <div class="menu">
        <div class="menu-header flex-row-justify-space-between">
          <p class="font-bold font-size-30 flex-center">用户</p>
          <p class="font-size-14 font-color-264480 flex-center font-bold cursor" @click="changeAllMenu">{{ menuAllShow?'全部收起':'全部展开' }}</p>
        </div>
        <div class="menu-content">
  
          <!-- 类型 -->
  
          <div class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">类型</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.typeCode.show?'transform':''" data-typ="widthheight" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.typeCode.show">
              <div v-if="menu && menu.length">
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu" :key="cate.typeName" class="menu-content-item-list-item" @click="selectCate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.typeCode.current == cate.typeCode?'bg-262A33':''">
                      <p class="font-size-14">{{ cate.typeName }}</p>
                      <p v-if="cate.typeCount>0" class="font-size-14 font-color-999">{{ cate.typeCount }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      menu: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        menuAllShow: false,
        menuDisplay: {
          typeCode: {
            show: false,
            current: null
          }
        }
      }
    },
    watch: {
      menu() {
        this.prepearData()
      }
    },
    created() {
    },
    methods: {
      prepearData() {
        this.menuAllShow = false
        this.changeAllMenu()
      },
      changeAllMenu() {
        this.menuAllShow = !this.menuAllShow
        for (const key in this.menuDisplay) {
          if (Object.hasOwnProperty.call(this.menuDisplay, key)) {
            const value = this.menuDisplay[key]
            value.show = this.menuAllShow
          }
        }
      },
      closeMenu() {
        this.menuDisplay.typeCode.show = !this.menuDisplay.typeCode.show
      },
      selectCate(v) {
        this.menuDisplay.typeCode.current = v.typeCode
        this.$emit('params', { params: { typeCode: v.typeCode }, display: v.typeName, type: 'typeCode' })
      },
      removeFilter(v) {
        this.menuDisplay[v].current = null
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    ::v-deep .el-select-dropdown__item{
      color: red($color: #000000) !important;
    }
    ::v-deep .el-input__icon{
      display: none;
    }
  
    ::v-deep .el-range-separator {
      width: 12% !important;
      line-height: 28px !important;
      color: #999 !important;
    }
  
    ::v-deep .el-range__close-icon {
      width: 0px !important;
    }
  
    ::v-deep .el-range-input {
      width: 44% !important;
    }
  
  </style>
  <style src="@/styles/pc.css" scoped>
  </style>
  <style scoped>
    .page {
       width: 280px;
    }
    .menu {
      width: 280px;
    }
  
    .page  .menu .menu-header {
      height: 40px;
      width: 100%;
    }
  
    .page .menu .menu-content {
      margin-top: 20px;
    }
  
    .page  .menu .menu-content .menu-content-item {
      background-color: #F3F4F9;
      margin-bottom: 10px;
      /* padding-bottom: 10px; */
    }
  
    .page .menu .menu-content .menu-content-item .menu-content-item-top {
      height: 60px;
      padding: 0 20px;
    }
  
    .page  .menu .menu-content .menu-content-item-line {
      width: 100%;
      height: 1px;
      background-color: #264480;
      opacity: 0.1;
    }
  
    .page  .menu .menu-content .menu-content-item-list {
      padding: 10px;
    }
  
    .menu-content-item-list-item-hg {
      height: 30px;
      padding: 0 10px;
    }
  
    .page  .menu .menu-content .menu-content-item-list-item-sel {
      background-color:  rgba(38, 42, 51, 0.4);
    }
  
    .page .menu .menu-content .menu-content-item-list-item-sel .menu-content-item-list-item-sel-text{
      color: #fff;
    }
  
    .menu-content-item-list-item-child {
      height: 30px;
      padding: 0 10px;
    }
  
    .menu-content-item-list-item-children {
      padding-left: 5px;
    }
  
    .menu-content-item-list-item-rang {
      width: 170px;
      height: 30px;
      border: 1px solid rgba(26, 59, 128, 0.2);
    }
  
    .menu-content-item-list-item-rang .start {
      left: 0;
      width: 60px;
      z-index: 99;
      opacity: 0;
    }
  
    .menu-content-item-list-item-rang .end {
      left: 0;
      width: 60px;
      z-index: 99;
      opacity: 0;
    }
  
    .menu-content-item-list-item-rang>div {
      padding: 0 10px;
    }
  
    .menu-content-item-list-item-button {
      width: 60px;
      height: 30px;
      margin-left: 10px;
    }
  
    .menu-content-item-more {
      height: 30px;
      padding-right: 10px;
    }
  
    .transform {
      transform: rotate(180deg);
    }
  
  </style>
  